import * as Zod from 'zod';

export const rizerScheme = Zod.object({
  id: Zod.number(),
  label: Zod.string(),
});
